<template>
  <BaseSelect v-bind="$attrs"
              :value="value"
              :options="items"
              textKey="name"
              cancelable
              :disabled="isDisabled"
              @focus="onSelectFocus"
              @input="onInput"/>
</template>

<script>
  import {CancelToken} from 'axios'
  import {http} from '@/axios'

  export default {
    name: 'SCountry',
    props: {
      value: {
        type: [Object, String]
      },
      countryId: {
        type: Number
      },
      params: {
        type: Object
      },
      url: {
        type: String,
        default: '/api/helper/countries',
      },
      prefetch: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      disabledOnEmptyList: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        loaded: false,
        pending: false,
        timer: null,
        items: [],
      }
    },
    computed: {
      isDisabled() {
        return this.disabled || (this.disabledOnEmptyList ? !this.items.length : false);
      },
    },
    methods: {
      load(search, toggleLoading) {
        if (this.loaded) return
        if (toggleLoading) toggleLoading(true)
        this.pending = true
        if (this.cancel) this.cancel()

        const params = {
          ...(this.params || {})
        }
        if (search) {
          params.search_query = search
        }

        http.get(this.url, {
          params,
          cancelToken: new CancelToken((c) => this.cancel = c)
        }).then(({data}) => {
          this.items = data.data
          if (!search) {
            this.loaded = true
          }

        }).finally(() => {
          this.pending = false
          if (toggleLoading) toggleLoading(false)
        })
      },
      loadById(id) {
        if (!id) return
        this.pending = true

        http.get(`/api/helper/country/${id}`).then(({data}) => {
          this.$emit('loaded', data.data)
        }).finally(() => {
          this.pending = false
        })
      },
      checkShouldLoadById() {
        let id = this.countryId || this.$route.query['country_id']

        if (
          !id ||
          this.value &&
          this.value.id.toString() === id.toString()
        ) return

        if (id) {
          this.loadById(id)
          return true;
        }
      },
      onSearch(search, toggleLoading) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.load(search, toggleLoading)
        }, 300)
      },
      onSelectFocus(toggleLoading) {
        this.load(null, toggleLoading)
      },
      onInput(value) {
        this.$emit('input', value)
      }
    },
    created() {
      const byId = this.checkShouldLoadById()
      if (!byId && this.prefetch) this.load();
    },
    watch: {
      '$route.query.country_id'() {
        this.checkShouldLoadById()
      },
      'countryId'() {
        this.checkShouldLoadById()
      },
      params() {
        this.loaded = false
      }
    }
  }
</script>

<style lang="less">

</style>
